// extracted by mini-css-extract-plugin
export default {"albumSelect":"AlbumSelect_albumSelect__u1d6C","albumsList":"AlbumSelect_albumsList__yXVI8"};